import { Button, Stack, Typography } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'
import { Fade, TextInputFieldProps } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { TextInputCell } from './Commons'

type LimitIssueInputCellProps = {
  setValue: UseFormSetValue<CreateItemProps>
  hasPurchaseLimitByUser: boolean
  inputProps: Omit<TextInputFieldProps, 't'>
  defaultNumber?: number
}
export const LimitIssueInputCell: Cell<LimitIssueInputCellProps> = ({
  hasPurchaseLimitByUser,
  setValue,
  inputProps,
  defaultNumber = 1,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const options = [
    { value: true, label: t('limited') },
    { value: false, label: t('noLimit') },
  ]
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('limitIssuedNumberLabel')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('limitIssuedNumberDescSKU')}
      </Typography>
      <Stack direction="row" spacing={2} sx={{ py: 2 }}>
        {options.map((option, index) => (
          <Button
            key={index}
            variant={
              hasPurchaseLimitByUser === option.value ? 'contained' : 'outlined'
            }
            onClick={() => {
              setValue('hasPurchaseLimitByUser', option.value)
              if (!option.value) {
                setValue('purchaseLimitByUser', null, {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              } else {
                setValue('purchaseLimitByUser', defaultNumber, {
                  shouldValidate: true,
                  shouldDirty: false,
                })
              }
            }}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
      {hasPurchaseLimitByUser && (
        <Fade>
          <TextInputCell textFieldProps={{ sx: { mb: 0 } }} {...inputProps} />
        </Fade>
      )}
    </CellFrame>
  )
}
